<template lang="pug">
b-card.adminCard
  b-form
    b-form-group(label='Email')
      b-form-input(v-model='form.email' :state="validateState('email')")
      b-form-invalid-feedback This field must be a valid email
    b-form-group(label='Password' description='leave blank to keep the same password')
      b-form-input(v-model='form.password' type='password' :state="validateState('password')")
      b-form-invalid-feedback
        span(v-if='!$v.form.password.required') This field is required
        span(v-else-if='!$v.form.password.minLength') Password should be at least 8 characters
        span(v-else='!$v.form.password.minLength') Password should contain at least a number, an uppercase letter, a lowercase letter and a special character.
    b-form-group(label='Role')
      b-form-select(v-model='form.role' :options="roleOptions")
      b-form-invalid-feedback This field is required
    b-form-group(label='Pin Code' v-if='!isUser')
      b-form-input(v-model='form.pin'  :state="validateState('pin')")
      b-form-invalid-feedback This field is required for Admins and Managers
    b-form-group
      b-button(@click='submit' :disabled='processing')
        b-spinner(small v-if='processing').mr-2
        span Save
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { email, minLength, numeric, required } from 'vuelidate/lib/validators'
import { Maybe, Role, AdminCreateInput, AdminQuery } from '@/generated/graphql'
@Component({})
export default class Form extends Vue {
  @Prop() admin: Maybe<AdminQuery['admin']>
  @Prop() saving

  get processing () {
    return this.saving
  }

  form = {
    email: '',
    password: '',
    role: Role.User,
    pin: ''
  }

  get roleOptions () {
    return Object.entries(Role).map(([key, value]) => {
      return {
        text: key,
        value
      }
    })
  }

  get isUser () {
    return this.form.role === Role.User
  }

  get passwordValidations () {
    if (!this.admin || this.form.password !== '') {
      return {
        required: !this.admin,
        minLength: minLength(8),
        containsUppercase: function (value: string) {
          return /[A-Z]/.test(value)
        },
        containsLowercase: function (value: string) {
          return /[a-z]/.test(value)
        },
        containsNumber: function (value: string) {
          return /[0-9]/.test(value)
        },
        containsSpecial: function (value: string) {
          return /[#?!@$%^&*-]/.test(value)
        }
      }
    } else {
      return {}
    }
  }

  validations () {
    return {
      form: {
        email: { required, email },
        password: this.passwordValidations,
        role: { required },
        pin: !this.isUser ? { required, minLength: minLength(4), numeric } : {}
      }
    }
  }

  validateState (name) {
    const $dirty = this.$v.form[name]?.$dirty
    const $error = this.$v.form[name]?.$error
    return $dirty ? !$error : null
  }

  created () {
    if (this.admin) {
      this.form.email = this.admin.email
      this.form.role = this.admin.role
      this.form.pin = String(this.admin.pin)
    }
  }

  async submit () {
    this.$v.form.$touch()
    if (this.$v.form.$anyError) return

    const payload: AdminCreateInput = {
      email: this.form.email,
      password: this.form.password,
      role: this.form.role,
      pin: this.form.pin ? Number(this.form.pin) : null
    }

    this.$emit('save', payload)
  }
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 2rem;
}
.actions {
  margin-bottom: 20px;
  text-align: right;
}
</style>
